export default __webpack_public_path__ + "static/media/Minting NFT.8a8bb49d.gif";